import ImageSlider from "../Components/Carousel/Slider";
import { SliderData } from '../Components/Carousel/SliderData';
import '../Styles/Slider.css'
import "../Styles/Hero.css";

function Hero() {
  return (
    <div className="section-container">
      <div className="hero-section">
        <div className="text-section">
          <h2 className="text-title">
            Find Your Perfect Stone
          </h2>
          <p className="text-descritpion">
            Explore a premium selection of natural granite and marble products crafted to perfection.
            We provide customized cutting, polishing, and finishing solutions for commercial and
            residential projects. Our commitment to quality and precision ensures enduring elegance
            in every stone we deliver.
          </p>
        </div>

        <div className="hero-image-section">
          <ImageSlider slides={SliderData} />
        </div>
      </div>
    </div>
  );
}

export default Hero;
